import { type FC } from "react";
import { useTranslation } from "react-i18next";
import type { SalesAttributionOverlapStats } from "../utils/salesAttributionTypes";
import OverlapVennChart from "./OverlapVennChart";
import { panelTooltip, SalesAttributionPanel } from "./salesAttributionShared";

interface SalesAttributionOverlapSectionProps {
  overlap: SalesAttributionOverlapStats;
}

export const SalesAttributionOverlapSection: FC<
  SalesAttributionOverlapSectionProps
> = ({ overlap }) => {
  const { t } = useTranslation();

  return (
    <SalesAttributionPanel
      title={t("salesAttribution.ui.panelTitles.overlap", {
        defaultValue: "Platform overlapping revenue and orders",
      })}
      definition={panelTooltip(
        t,
        "overlap",
        "Each platform counts an order if it saw a touch inside its own attribution window. When two platforms both saw one, both claim the sale - adding their numbers together over-counts by exactly this slice."
      )}
    >

      <div className="sales-attribution__venn-grid">
        <OverlapVennChart
          title={t("salesAttribution.ui.overlapOrdersTitle", { defaultValue: "Overlapping orders" })}
          stats={overlap.orders}
        />
        <OverlapVennChart
          title={t("salesAttribution.ui.overlapRevenueTitle", { defaultValue: "Overlapping revenue" })}
          stats={overlap.revenue}
        />
      </div>
    </SalesAttributionPanel>
  );
};

export default SalesAttributionOverlapSection;
